'use client';

import { Box, SxProps, Theme } from '@mui/material';
import { BrushboxColors, BrushboxVariants } from './Brushbox.interfaces';

import { ReactNode, Suspense } from 'react';
import dynamic from 'next/dynamic';
import { brushBoxContainerStyles, imageSxProps } from './Brushbox.styled';

const BrushboxBackgroundWide = dynamic(
  () => import('./components/BrushboxBackgroundWide/BrushboxBackgroundWide'),
  { ssr: false }
);

const BrushboxBackgroundRectangle = dynamic(
  () =>
    import(
      './components/BrushboxBackgroundRectangle/BrushboxBackgroundRectangle'
    ),
  { ssr: false }
);

const BrushboxBackgroundTall = dynamic(
  () => import('./components/BrushboxBackgroundTall/BrushboxBackgroundTall'),
  { ssr: false }
);

export interface BrushboxProps {
  id?: string;
  children: ReactNode;
  variant: BrushboxVariants;
  color: BrushboxColors;
  sx?: SxProps;
  brushSx?: SxProps;
}

export default function Brushbox({
  id,
  children,
  variant,
  sx,
  color = BrushboxColors.Black,
  brushSx,
}: BrushboxProps) {
  const BoxVariant = (() => {
    if (variant === BrushboxVariants.Wide) {
      return <BrushboxBackgroundWide color={color} />;
    }

    if (variant === BrushboxVariants.Rectangle) {
      return <BrushboxBackgroundRectangle color={color} />;
    }

    if (variant === BrushboxVariants.Tall) {
      return <BrushboxBackgroundTall color={color} />;
    }
  })();
  return (
    <Box
      id={id}
      sx={brushBoxContainerStyles(sx)}
    >
      <Box sx={{ ...brushSx, ...imageSxProps({ variant }) } as SxProps<Theme>}>
        <Suspense>{BoxVariant}</Suspense>
      </Box>
      {children}
    </Box>
  );
}
